import React from 'react';
import { formatText } from 'core/i18n';

const IdentificationMoreDetailsModalImages = ({ images }) => (
    <div className="images">
        {images.map(image => (
            <img src={image.img} alt={formatText(image.description)} key={image.description} />
        ))}
    </div>
);

export default IdentificationMoreDetailsModalImages;
